/**
 * Tenant portal API client
 */

import { createApiClient } from '@intellimon/shared/api';
import { tenantTokens } from '@intellimon/shared/utils';

export const tenantApi = createApiClient({
  baseURL: '/api/v1',
  includeTenantSlug: true,
  getAccessToken: tenantTokens.getAccessToken,
  getRefreshToken: tenantTokens.getRefreshToken,
  getTenantSlug: tenantTokens.getTenantSlug,
  onTokenRefresh: (accessToken, refreshToken) => {
    tenantTokens.setAccessToken(accessToken);
    tenantTokens.setRefreshToken(refreshToken);
  },
  onAuthError: () => {
    tenantTokens.clearTokens();
    window.location.href = '/app/login';
  },
  refreshEndpoint: '/auth/refresh',
});
